export default __webpack_public_path__ + "static/media/toforov.e5d2010e.png";